module.exports = __webpack_public_path__ + "a534104226a0a874b12d7f006a33a49a.png";